import { Typography } from '@mui/material';
import JourneyCardLayout from '@acorn-portal/shared/src/layouts/journey-card-layout';
import VerifyCustomerForm from '@acorn-portal/shared/src/components/forms/VerifyCustomerForm';

const VerifyAccount = () => {
	return (
		<JourneyCardLayout pageTitle='Verify your identity' loading={false}>
			<Typography
				sx={{
					textAlign: 'center',
					marginBottom: 4,
					maxWidth: { md: '70%' },
					marginLeft: 'auto',
					marginRight: 'auto',
				}}
			>
				Please provide your date of birth and vehicle registration number below so that we can verify your identity.
				Once you have entered the details please click Continue.
			</Typography>
			<VerifyCustomerForm />
		</JourneyCardLayout>
	);
};

export default VerifyAccount;
